export default {
    site: {
        common: {
            hello: "Bonjour",
            thankYou: "Merci",
            forMoreInfo: "pour plus d'informations",
            hoverOverColumnHeaders: "Passez la souris sur les en-têtes de colonne pour plus d'informations.",
            username: "nom d'utilisateur",
            score: "Score",
            points: "Points",
            pointsAbbreviation: "pts",
            chapter: "Chapitre",
            tier: "Tier",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Productions par jour",
            relicBoostPercent: "Boost de reliques (%)",
            mountainHallPercentShort: "CdM %", // used in table heading keep it short.
            updated: "Mis à jour",
            lastUpdated: "Dernière actualisation",
            created: "créé",
            role: "rôle",
            Fellow: 'Membre',
            Ambassador: 'Émissaire',
            Mage: 'Mage',
            Archmage: 'Archimage',
            saveChanges: "Sauvegarder les modifications",
            copy: "Copier",
            close: "Fermer",
            cancel: "Annuler",
            action: "Action",
            date: "Date",
            Left: "Départ",
            Joined: "Arrivée",
            human: "Humain",
            elf: "Elfe",
            search: "recherche",
            enter: "Entrer",
            yes: "Oui",
            no: "Non",
            tournament: "Tournoi",
            tournaments: "Tournois",
            fellowship: "Confrérie",
            player: "Joueur",
            member: "Membre",
            history: "Historique",
            tournamentHistory:  "Historique du tournoi",
            scoreHistory: "Historique du score",
            server: "Serveur",
            lastWeekGain: "Derniers gains",
            comingSoon: "Prochainement",
            chest: "coffre",
            yourServer: "Vos serveurs",
            allServers: "Tous les serveurs",
            boosts: "Boosts",
            marble: "Marbre",
            steel: "Acier",
            planks: "Planches",
            crystal: "Cristal",
            scrolls: "Parchemins",
            silk: "Soie",
            elixir: "Élixir",
            magic_dust: "Poussière magique",
            gems: "Gemmes",
            sentient: "Sensible",
            goods: "Marchandises",
            average: "moyen",
            expansions: 'Extensions', // 5x5 grids
            cultureBoostMinimum: 'Bonus de culture minimum',
            cultureBoostCalculated: 'Bonus de culture calculé',
            neighborlyHelp: 'Aide entre voisins',
            neighborlyHelpAbbreviation: 'AV'
        },
        // HIGH PRIORITY
        nav: {
            home: "Accueil",
            players: "Joueurs",
            fellowships: "Confréries",
            tournaments: "Tournois",
            contact: "Contact",
            donate: "Dons",
            faq: "Foire Aux Questions",
            news: "Nouveautés",
            privacyPolicy: "Politique de confidentialité",
            me: "Moi",
            myFellowship: "Ma confrérie",

            // NOTE USED AT THE MOMENT
            globalStats: "Statistiques globales",
            articles: "Articles",
            fellowshipAdventure: "Aventures de confrérie",
            recruit: "Recrutement",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Voir sa cité sur ElvenArchitect",
            obtainingLink: "Obtention du lien",
            successMessage: "Cliquez sur le lien ci-dessous pour ouvrir ElvenArchitect",
            ageOfLink: "Le lien ci-dessus montrera la ville telle qu'elle était auparavant : ",
            clickToGetCurrentCity: "<-- Cliquez pour obtenir la ville actuelle",
        },
        // High Priority
        playerSelection: {
            headline: "Voir le site sous",
            description: "Ceci met à jour les différentes parties du site qui sont personnalisées pour chaque utilisateur. Exemples : Ma confrérie, Moi, Tounois, et les pages de classement notamment.",
            youAreViewing: "Vous consultez actuellement le site en tant que {username} sur {serverName}.",
            changeUser: "Changer de joueur",
            enterYourUsernameToGetStarted: "Entrez votre nom d'utilisateur d'Elvenar pour commencer",
            thisIsNotASignup:"Ce n'est pas un processus d'inscription. En entrant votre pseudo de joueur, nous personnalisons simplement le site de manière appropriée. Il y a beaucoup de serveurs Elvenar et nous afficherons les résultats de classement pour votre serveur. De plus, des pages concernant votre confrérie et vos pages personnelles seront disponibles.",
        },
        searchBoxes: {
            enterFellowshipName: "Entrez le nom de votre confrérie",
            instructions: "Tapez le nom et sélectionnez-en un.",
            noFellowship: "Aucune confrérie",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "Il y a quelques jours",
            minsAgo: "Il y a quelques minutes",
            hoursAgo: "Il y a quelques heures",
            justNow: "Maintenant",
            never: "Jamais",
        },
        home: {
            welcome: "Bienvenue sur ElvenStats !",
            youAreViewing: "Vous consultez actuellement le site en tant que {username} sur {serverName}",
            youCanChange: "Vous pouvez changer l'utilisateur en cliquant sur l'avatar en haut à droite -ou- par <router-link to='/contact'>en visitant cette page</router-link>",
            features: {
                headline: "Fonctionnalités",
                fellowshipAdministration: {
                    headline: "La gestion d'une confrérie, <strong>c'est facile !</strong>",
                    bullet1: "Suivi automatique des marchandises boostées pour vous aider à mieux équilibrer votre production",
                    bullet2: "Suivi automatique et génération de courriels de rapports hebdomadaires incluant les points, la participation aux tournois, la croissance mensuelle et les \"Accolades\" motivantes et les records individuels",
                    bullet3: "Aide à identifier les déséquilibres de production de vos confrères, tels que les matériaux ou le ratio incorrect des boosts",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Intégration</strong> de ElvenArchitect",
                    description: "Téléchargez votre ville exactement comme elle l'est sur ElvenArchitect en quelques secondes ! Utilisez cet outil pour mieux planifier votre prochaine réorganisation ou pour libérer de la place ! Recherchez le logo ElvenArchitect sur les pages de chaque joueur.",
                },
                advancedRankingLists: {
                    headline: "<strong>Listes des classements</strong> avancés",
                    bullet1: "Classement par provinces explorées (pour vous comparer aux joueurs au même stade)",
                    bullet2: "Voir les boosts, le chapitre, et davantage, dans les listes de joueurs",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Suivi</strong> des tournois de confrérie",
                    description: "Comparez votre confrérie avec les autres. Défiez d'autres confréries à un tournoi pour une compétition amicale!",
                },
                matchMaking: {
                    headline: "<strong>Adéquation</strong>",
                    description: "ElvenStats suit les boosts des joueurs et les ratios de production des marchandises des confréries. Avec ces informations, les confréries peuvent recruter les candidats idéaux pour équilibrer leurs productions de marchandises. En outre, les joueurs à la recherche d'une confrérie peuvent en trouver une selon leurs besoins et attentes. Ainsi : Gagner du temps et réduire le rejet !",
                },
            },
        },
        fellowship: {
            stats: {
                rank: "Rang",
                points: "Points",
                medianUserScore: "Moyenne de <strong>score des joueurs</strong>",
                memberCount: "<strong>Nombre</strong> de membres",
            },
            barCharts: {
                clickSlice: "Cliquez sur une barre pour plus de détails (par membre)",
                tier1: "Tier 1",
                tier2: "Tier 2",
                tier3: "Tier 3",
                drillDown: "Retour à {0}",
            },
            idealCandidate: {
                heading: "Candidat idéal",
                description: "Aurait un score autour de {medianScore} et aurait un ou plusieurs des boosts suivants: {boosts}",
                note: "Certaines combinaisons de boosts ne sont pas possibles. Voir {0}",
            },
            memberGoodsTable: {
                heading: "Productions de marchandises des membres",
                description: "Ce tableau calcule la quantité que produit votre confrérie pour chaque marchandise. Nous avons estimé les pourcentages de boosts de reliques de chaque membre et, par défaut, nous supposons que chaque joueur effectue 3 collectes par jour (2x9h et 1x3h). Pour en améliorer l'exactitude, demandez aux membres de votre confrérie quelles sont leurs valeurs réelles et entrez-les ci-dessous. Vous pouvez enregistrer vos modifications afin que les nouvelles données apparaissent à chaque fois que vous chargez cette page. Les diagrammes ci-dessus seront automatiquement mis à jour après avoir apporté des modifications. Remarque : Passez la souris sur les en-têtes de colonne pour plus d'informations sur une colonne particulière.",
                refreshButtonText: 'Rafraîchir la liste des membres',
                refreshButtonTip: 'Cela ajoutera les nouveaux membres, supprimera les anciens membres, mettra à jour les rôles de la confrérie et mettra à jour les scores.',
                inactiveWarningTip: "Le joueur peut être inactif, score Dernière mise à jour: {0}",
                collectsPerDayValidation: "Doit être entre 1-6",
                boostPercentValidation: "Doit être compris entre 40 et 700, n'incluez pas le bonus du coeur de la montagne",
                perDayShort: "/jour",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Le score des joueurs. Veuillez noter que ce n'est pas mis à jour en temps réel. Il est mis à jour plusieurs fois par semaine.",
                chapterTip: "C'est le chapitre dans lequel se trouve chaque joueur.<br/>Pour références : Élementaires = 12, Halfelins = 11, etc, ...",
                boostTip: "Boost du joueur et la quantité produite par jour.",
                collectsPerDayTip: `***EDITABLE***<br/>Collectes par jour. C'est le nombre de fois par jour que le joueur collecte des marchandises depuis ses manufactures. Il doit s'agir d'une valeur comprise entre 1 et 6. 1 = 1x24h, 2 = 2x9h, 3 = 2x9h + 1x3h, 4 = 1x9h + 3x3h, 5 = 4x3h + 1x9h, 6 = 5x3h + 1x9h<br/>Consultez la FAQ pour plus d'informations.`,
                relicBoostPercentTip: `***EDITABLE***<br/>Le pourcentage de boost des reliques, compris entre 40 et 700. Ne pas inclure le bonus du Coeur de la Montagne. Cela est automatiquement détecté et est compris dedans.`,
                mountainHallPercentTip: "C'est le bonus du Coeur de la Montagne que nous avons détecté pour ce joueur. Il est utilisé en conjonction avec le boost % pour calculer le pourcentage de boost total.",
                updatedTip: "C'est la dernière fois que la ville a été analysée. Ce processus permet de définir les boosts, les données de ElvenArchitect, calcule la production de toutes les manufactures, le bonus du Coeur de la Montagne, et plus encore. Les données de la carte de la ville sont récupérées automatiquement mais vous pouvez forcer une mise à jour ci-dessous en cliquant sur le bouton d'actualisation.",

            },
            coinsAndSuppliesTable: {
                heading: "Production de pièces / matériaux",
                description: "La colonne clé ici est « Matériaux / pièces restants » car elle indique si un membre produira suffisamment de matériaux pour que ses manufactures produisent 24/7. Utilisez les commutateurs à bascule ci-dessous pour prendre en compte le boost minimum de culture des joueurs (qui est le boost que vous auriez si vous n'aviez pas d'aide de voisinage) et / ou le nombre de fois que le membre collecte par jour. Les désactiver est utile si vous voulez voir combien de matériaux sont attribuées à plus de manufactures ou à une augmentation de la culture. Enfin, veuillez noter que le nombre de matériaux restants est très faible (~ 10% du total). Il existe de nombreuses façons pour les joueurs d'augmenter leurs stocks, comme par exemple en visitant des voisins, en produisant des matériaux à des intervalles plus rapides (Breuvages, Outils rudimentaires, Pain, ...) ou en utilisant les sorts « Puissance des matériaux ». Remarque : pour le moment, la production de troupes n'est pas prise en compte dans les matériaux utilisés (seulement les marchandises de niveau 1, de niveau 2 et de niveau 3), vous pourriez donc en avoir besoin de plus.",

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Bonus de culture",
                made: "Produit",
                used: "Utilisé",
                left: "Restant",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Le pourcentage de boost de culture.<br/>Important : ceci est calculé en supposant qu'il n'y a PAS d'aide entre voisins. En réalité, ce sera probablement plus élevé dans vos villes.",
                moneyComputedTip: "La quantité de pièces produites en 24 heures comprend toutes les merveilles antiques qui produisent des pièces d'or.",
                moneyUsedComputedTip: "La quantité de pièces consommées par la production de marchandises.",
                moneyRemainingComputedTip: "Pièces - Pièces utilisées : c'est le surplus ou le déficit de pièces qu'un joueur aura chaque jour.",
                suppliesComputedTip: "Le nombre de matériaux qui seraient produits si tous les ateliers étaient réglés sur 24x1 (boîtes à outils) ainsi que toutes les merveilles antiques.<br/>Attention : n'inclut pas les bonus de set.",
                suppliesUsedComputedTip: "Le nombre de matériaux consommés par la production de marchandises.<br/>Attention : N'inclut pas les matériaux utilisés par la production d'unités (voir l'explication ci-dessus).",
                suppliesRemainingComputedTip: "Matériaux - Matériaux utilisés : c'est le surplus ou le déficit de matériaux qu'un joueur aura chaque jour.",
                manaTip: "La quantité de Mana produite en 24 heures.<br/>Attention : n'inclut pas l'Abbaye du Dragon.",
            },
            popCultureTable: {
                heading: "Détails Population/Culture",
                description: "Le tableau ci-dessous indique la population et la culture pour chaque membre. Remarque : passez la souris sur les en-têtes de colonne pour plus d'informations.",

                // Icon Sub-Headings
                minBoostPercent: "Boost min.",
                levels: "Niveaux",
                total: "Total",
                working: "Au travail",
                available: "Disponible",
                required: "Requis",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Le nombre total de niveaux de merveilles antiques qu'un joueur a.",
                cultureBoostPercentTip: "Le pourcentage de boost de culture.<br/>Important : ceci est calculé en supposant qu'il n'y a PAS d'aide entre voisins. En réalité, cela sera probablement plus élevé dans vos villes.",
                totalPopulationTip: " Population totale produite par les résidences, les bâtiments hybrides culture / population et les merveilles antiques.",
                workingPopulationTip: "Population active - La quantité consommée par les bâtiments",
                availablePopulationTip: "Population disponible.",
                totalCultureTip: "Culture totale produite par les bâtiments culturels, les bâtiments hybrides culture / population et les merveilles antiques.",
                requiredCultureTip: "Culture requise pour tous vos bâtiments.",
                availableCultureTip: "Culture diponible.",
            },
            cityCoverageTable: {
                heading: "Extensions de la ville",
                description: "Indique le nombre d'extensions utilisées dans chaque ville pour un type de bâtiment particulier. Les extensions vides sont des extensions qui ne sont pas utilisées actuellement.",
                tiles: 'Extensions'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Rapport hebdomadaire par e-mail",
                description: "Nous générons automatiquement des rapports hebdomadaires pouvant être partagés avec les membres de votre confrérie. Un nouveau rapport hebdomadaire sera disponible chaque dimanche (à 20:00 UTC environ) pour la semaine venant de s'écouler. Copiez simplement le texte ci-dessous et collez-le !",
                selectReportHint: "Sélectionnez le rapport pour la fin de semaine",
                reportsAreOptimizedFor: "Les rapports de courrier électronique sont optimisés pour l'affichage dans le système de messagerie Elvenar, de sorte que les colonnes s'alignent le mieux possible et que les noms d'utilisateur soient tronqués afin de ne contenir qu'un seul message.",
                accolades: "accolades",
                tourneyChamp: " - Meilleur joueur (cette semaine) : {0}",
                tourneyHero: " - Meilleur joueur (les 4 dernières semaines) : {0}",
                highestGrowthPlusPercentage: " - La plus forte croissance (points et pourcentage) : {0}",
                highestGrowthPoints: " - Plus forte croissance (points) : {0}",
                highestGrowthPercentage: " - Plus forte croissance (pourcentage) : {0}",
                highestGrowthError: " - Plus forte croissance : Ne peut pas encore être déterminé, besoin d'un meilleur historique",
                newPersonalRecords: "Nouveaux records personnels",
                userSetANewPersonalRecordFor: " * {0} définit un nouveau record personnel pour : {1}",
                allMembersByPointGainThisWeek: "TOUS LES MEMBRES PAR POINTS GAGNÉS / Pourcentage (cette semaine)",
                tournamentPointsHeader: "Points de TOURNOI (cette semaine / TOTAL DEPUIS {0})",
                top8ByPercentage: "TOP 8 en pourcentage (cette semaine)",
                top8ByPointsSince: "TOP 8 en points (Depuis {0})",
                top8ByPercentageSince: "TOP 8 en pourcentage (Depuis {0})",
                reportGeneratedBy: "Rapport généré par elvenstats.com, pour plus d'informations, voir :",
                mostPointsInAWeek: "Le plus de points en une semaine",
                highestTournamentScore: "Score le plus élevé du tournoi",
                highestTournamentRank: "Place la plus élevée du tounoi",
                insufficientHistoryForThesePlayers: "* Omis : {0} en raison d'un historique insuffisant. Ils seront inclus la semaine prochaine ",
                insufficientHistory1Week: "* Historique insuffisant pour cette section. Revenez la semaine prochaine!",
                insufficientHistory4Weeks: "* Historique insuffisant pour cette section. 4 semaines d'historique sont nécessaires. Revenez bientôt !",
            },
            memberHistory: {
                heading: "Historique des membres",
                noChangesDetected: "Aucun changement de membre détecté depuis le début du suivi de la confrérie sur {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: "Vous avez des changements non enregistrés. Lorsque vous avez fini d'éditer votre confrérie, cliquez sur le bouton Enregistrer.",
                standbyImporting: "Standby : Nous importons certains de vos confrères qui manquent d'informations",
                limitedHistory: "Nous avons très récemment commencé à suivre ce {0}, donc l'historique est limité. Chaque dimanche, des données hebdomadaires seront affichées ici, alors revenez vite !",
                noChangesSinceTrackingBegan: "Aucun changement depuis le début du suivi.",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Historique de la confrérie"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Les mises à jour en temps réel sont indisponibles en ce moment.",
            realTimeUpdatesNotAvailableDescription: "Ceci arrive typiquement après que les serveurs de jeu soient redémarrés pour déployer une mise à jour ou pour une maintenance. Dés lors que ceci arrive, ElvenStats doit être manuellement reconnecté à tous les serveurs de jeu avant que les informations ne soient recouvrées sur demande. Merci de réessayer dans plusieurs heures. En attendant, le site est pleinement opérationnel.",
            copyToClipboardSuccessful: "Copie dans le presse-papiers réalisée avec succès !",
            copyToClipboardFailed: "Échec de la copie, sélectionnez le texte entier et faites CTRL+C",
            errorOccurredImporting: "Une erreur est survenue en important les utilisateurs.",
            errorOccurredImportingMessage: "Une erreur est survenue en essayant d'importer les utilisateurs. Merci de réessayer ultérieurement. Si l'erreur persiste, merci de nous contacter.",
            errorOccurredImportingWillNotBeAvailableInReports: "Les utilisateurs qui n'ont pas été importés ne seront pas inclus dans les rapports.",
            finishedSyncSuccessful: "Terminé, la synchronisation a été réalisée avec succès !",
            playerIsAnonymous: "Le joueur a demandé à ce que ses informations ne soient pas indiquées sur elvenstats.com",
            inactiveWarningTip: "Ce joueur est probablement inactif. Dernière mise à jour du score : {0}",
            isFriendTip: "Ce joueur est un ami de ElvenStats. Il a donné de son temps ou de son argent pour soutenir le site !",
        },

        tournamentAverage4W: "Tournoi: <strong>Moyen</strong>",

    }

}


// WEBPACK FOOTER //
// ./src/lang/fr.js